import cls from "./unauthorized.module.scss";
import { useTranslation } from "react-i18next";
import PrimaryButton from "components/button/primaryButton";
import { useAuth } from "contexts/auth/auth.context";
import Image from "next/image";

type Props = {
  text: string;
};

export default function Unauthorized({ text }: Props) {
  const { t } = useTranslation();
  const { openAuthModal } = useAuth();

  return (
    <div className={cls.wrapper}>
      <Image
        width={350}
        height={350}
        src="/images/delivery.webp"
        alt="Unauthorized"
      />
      <p className={cls.text}>{text}</p>
      <div className={cls.actions}>
        <PrimaryButton onClick={() => openAuthModal()}>
          {t("login.or.create.account")}
        </PrimaryButton>
      </div>
    </div>
  );
}
